<template>
  <div class="alert alert-secondary" role="alert">
    <h4 class="alert-heading">{{ $t('permissions.noPermissions') }}</h4>
    <p>{{ $t('permissions.contactAdministrator') }}</p>
  </div>
</template>
